import { Box, Flex, HStack, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import useChangeStatus from "../../../shared/useChangeStatus";
import RoundCheckbox from "./RoundCheckBox";

const ReadingOrderListItem = ({
  readingId,
  comic,
  isUpNext,
  itemRef,
  disableTracking,
}) => {
  const { markAsRead, markAsSkipped, markAsReadLater, markAsUnRead } =
    useChangeStatus(readingId);
  const navigate = useNavigate();

  const onMarkAsRead = (item) => {
    if (disableTracking) {
      return;
    }
    const nextChecked = !item.read;
    nextChecked
      ? markAsRead(item.id, item.story)
      : markAsUnRead(item.id, item.story, item.skipped, item.readLater);
  };

  const onMarkAsSkipped = (item) => {
    if (disableTracking) {
      return;
    }
    !item.skipped
      ? markAsSkipped(item.id, item.story)
      : markAsUnRead(item.id, item.story, item.skipped, item.readLater);
  };

  const onMarkAsReadLater = (item) => {
    if (disableTracking) {
      return;
    }
    !item.readLater
      ? markAsReadLater(item.id, item.story)
      : markAsUnRead(item.id, item.story, item.skipped, item.readLater);
  };

  const onPressRow = (item) => {
    // mixpanel.track("list_item_row_tapped_app", { limitReached: true });
    navigate(`/comics/${item.id}/view`, {
      state: { comic: item, readingId },
    });
  };

  return (
    <Flex
      ref={itemRef}
      justifyContent="space-between"
      alignItems="center"
      py="3"
      borderBottomWidth="1px"
      borderBottomColor="gray.900"
      borderLeftWidth={"5px"}
      borderLeftColor={isUpNext ? "red.500" : "transparent"}
      bg={disableTracking ? "#101426" : undefined}
    >
      <Box px="3">{comic.order}.</Box>
      <Box flexGrow={2}>
        <Text
          fontSize="0.9em"
          lineHeight="1.25em"
          overflowWrap="break-word"
          wordBreak="break-word"
          cursor="pointer"
          onClick={() => onPressRow(comic)}
        >
          {comic.title} {comic.story && `[${comic.story}]`}
        </Text>
      </Box>
      <Box px="3">
        <HStack>
          <RoundCheckbox
            iconName={"read"}
            isChecked={comic.read}
            onChange={() => onMarkAsRead(comic)}
            readOnly={disableTracking}
            title="Mark as read"
          />
          <RoundCheckbox
            iconName={"skipped"}
            isChecked={comic.skipped}
            onChange={() => onMarkAsSkipped(comic)}
            readOnly={disableTracking}
            title="Skip"
          />
          <RoundCheckbox
            iconName={"readLater"}
            isChecked={comic.readLater}
            onChange={() => onMarkAsReadLater(comic)}
            readOnly={disableTracking}
            title="Read later"
          />
        </HStack>
      </Box>
    </Flex>
  );
};

export default ReadingOrderListItem;
